<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->

    <!-- BOC:[error] -->
    <AError
      v-if="api.isError"
      :api="api"
      :callbackReset="() => (api.isError = false)"
    />
    <!-- EOC -->

    <v-card class="mx-auto pa-3" max-width="800" outlined min-height="200">
      <v-row>
        <v-col><h2>Remove Mission</h2></v-col>
      </v-row>
      <v-card-title></v-card-title>

      <div class="d-flex align-center justify-space-around">
        <div class="form-content text-center">
          <v-alert border="bottom" colored-border type="error" elevation="2">
            This action is irreversible. Are you sure you want to remove mission?
          </v-alert>
          <div class="text-right">
            <v-btn color="error" class="mr-4" @click="submit" text>Yes</v-btn>
            <v-btn text @click="$router.go(-1)">No</v-btn>
          </div>
        </div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    // BOC:[breadcrumbs]
    breadcrumbs: [],
    // EOC
    name: null,
    mochiId: null,
    // APIs
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
      method: "GET",
    },
    deleteApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
      method: "POST",
    },
    studentApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
      method: "GET",
    },
  }),
  created() {
    // GET mission (after we know mochiId)
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      // optional: set mission name if available
      this.name =
        (resp && (resp.questionName || resp.questionKey || resp.id)) || null;
      this.updateBreadcrumb();
    };

    // DELETE mission
    this.deleteApi.callbackReset = () => {
      this.deleteApi.isLoading = true;
      this.deleteApi.isError = false;
    };
    this.deleteApi.callbackError = (e) => {
      this.deleteApi.isLoading = false;
      this.deleteApi.isError = true;
      this.deleteApi.error = e;
    };
    this.deleteApi.callbackSuccess = () => {
      this.deleteApi.isLoading = false;
      this.$router.push({
        name: "PageEducatorInstitutionClassroomStudentRead",
        params: {
          id: this.$route.params.parentId,
          parentId: this.$route.params.grandparentId,
          grandparentId: this.$route.params.supergrandparentId,
        },
      });
    };

    // Load student to get mochiId and build breadcrumbs, then fetch mission
    this.loadStudent();
  },
  methods: {
    loadStudent() {
      this.studentApi.url =
        this.$api.servers.sso +
        "/api/v1/" +
        this.$_getLocale() +
        "/educator/classroom/" +
        this.$route.params.grandparentId +
        "/student/" +
        this.$route.params.parentId;

      this.studentApi.callbackReset = () => {
        this.studentApi.isLoading = true;
        this.studentApi.isError = false;
      };
      this.studentApi.callbackError = () => {
        this.studentApi.isLoading = false;
        this.studentApi.isError = true;
        // still draw breadcrumbs without details
        this.updateBreadcrumb({});
      };
      this.studentApi.callbackSuccess = (resp) => {
        this.studentApi.isLoading = false;
        this.updateBreadcrumb(resp || {});
        this.mochiId = resp && resp.mochiId ? resp.mochiId : null;

        if (this.mochiId) {
          // wire mission GET and DELETE endpoints with mochiId
          this.api.url =
            this.$api.servers.game +
            "/api/v1/" +
            this.$_getLocale() +
            "/backend/player/" +
            this.mochiId +
            "/mission/" +
            this.$route.params.id;

          this.deleteApi.url =
            this.$api.servers.game +
            "/api/v1/" +
            this.$_getLocale() +
            "/backend/player/" +
            this.mochiId +
            "/mission/delete";

          this.$api.fetch(this.api);
        }
      };

      this.$api.fetch(this.studentApi);
    },

    updateBreadcrumb(resp) {
      const crumbs = [
        {
          text: "Dashboard",
          to: { name: "PageEducatorDashboard" },
          exact: true,
        },
      ];

      crumbs.push({
        text: "My Institution",
        to: {
          name: "PageEducatorInstitutionDashboard",
          params: { id: this.$route.params.supergrandparentId },
        },
        exact: true,
      });

      crumbs.push({
        text: "Classrooms",
        to: {
          name: "PageEducatorInstitutionClassroom",
          params: { id: this.$route.params.supergrandparentId },
        },
        exact: true,
      });

      // Classroom
      crumbs.push({
        text:
          resp && resp.Classroom && resp.Classroom.name
            ? resp.Classroom.name
            : "Classroom",
        to: {
          name: "PageEducatorInstitutionClassroomDashboard",
          params: {
            id: this.$route.params.grandparentId,
            parentId: this.$route.params.supergrandparentId,
          },
        },
        exact: true,
      });

      crumbs.push({
        text: "Students",
        to: {
          name: "PageEducatorInstitutionClassroomStudent",
          params: {
            id: this.$route.params.grandparentId,
            parentId: this.$route.params.supergrandparentId,
          },
        },
        exact: true,
      });

      // Student
      crumbs.push({
        text: (resp && resp.name) || "Student",
        to: {
          name: "PageEducatorInstitutionClassroomStudentRead",
          params: {
            id: this.$route.params.parentId,
            parentId: this.$route.params.grandparentId,
            grandparentId: this.$route.params.supergrandparentId,
          },
        },
        exact: true,
      });

      // Mission Info
      crumbs.push({
        text: "Mission",
        to: {
          name: "PageEducatorInstitutionClassroomStudentMissionRead",
          params: {
            id: this.$route.params.id,
            parentId: this.$route.params.parentId,
            grandparentId: this.$route.params.grandparentId,
            supergrandparentId: this.$route.params.supergrandparentId,
          },
        },
        exact: true,
      });

      // Remove
      crumbs.push({
        text: "Remove",
        to: {
          name: "PageEducatorInstitutionClassroomStudentMissionRemove",
          params: {
            id: this.$route.params.id,
            parentId: this.$route.params.parentId,
            grandparentId: this.$route.params.grandparentId,
            supergrandparentId: this.$route.params.supergrandparentId,
          },
        },
        exact: true,
      });

      this.breadcrumbs = crumbs;
    },

    submit() {
      this.deleteApi.params = { id: this.$route.params.id };
      this.$api.fetch(this.deleteApi);
    },
  },
};
</script>

<style scoped>
.menu-item {
  border: 1px solid black;
  margin: 3px;
}
.form-content {
  width: 600px !important;
}
</style>